import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { setSelectedDispositions } from "../store/slices/filtersSlice";

// Dashboard-style pages (Reporting, Analytics) break stats down BY
// disposition and have no disposition-filter control of their own. The
// disposition filter lives in global Redux state (not scoped per page), so
// clicking a disposition stat card on Reporting to jump into Call Logs
// leaves that filter active - and navigating back here without clearing it
// makes every OTHER disposition silently collapse to 0 (the backend only
// returns stats for whatever disposition is still filtered), which looks
// broken with no visible cause since these pages show no "filter active"
// indicator at all.
//
// Clearing it on mount keeps these overview pages always showing the full,
// unfiltered picture. Call Logs' own Dispositions filter button is
// unaffected - this hook is never used on that page.
export function useClearDispositionFilterOnMount() {
  const dispatch = useDispatch();
  // useLayoutEffect (not useEffect) so the clear is dispatched before the
  // browser paints - avoids a one-frame flash of the stale filtered (often
  // all-zero) stats before the re-query with the cleared filter resolves.
  useLayoutEffect(() => {
    dispatch(setSelectedDispositions([]));
    // Intentionally run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
